import * as React from "react";
import { MediaQuery } from "react-responsive";
import { EqualHeightProvider } from "../../equal-height/equal-height-provider/equal-height-provider.mjs";
import { ThemeContext } from "../../helpers/theme-provider/theme-provider.mjs";
const _HorizontalProgress = class _HorizontalProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false
    };
  }
  componentDidMount() {
    this.setState({
      isMounted: true
    });
  }
  BEM(stateClass) {
    const classArray = ["horizontal-progress", stateClass];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  renderUl() {
    return /* @__PURE__ */ React.createElement(EqualHeightProvider, { groups: ["horizontal-progress-item-title"] }, /* @__PURE__ */ React.createElement("ol", { className: "horizontal-progress__steps" }, this.props.children));
  }
  render() {
    if (this.state.isMounted) {
      const { media } = this.context;
      return /* @__PURE__ */ React.createElement(MediaQuery, { minWidth: media.width[this.props.break].min }, (matches) => /* @__PURE__ */ React.createElement("div", { className: this.BEM(matches ? "is-horizontal" : "is-vertical") }, this.renderUl()));
    }
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM("is-vertical") }, this.renderUl());
  }
};
_HorizontalProgress.contextType = ThemeContext;
_HorizontalProgress.defaultProps = {
  break: "lg"
};
let HorizontalProgress = _HorizontalProgress;
export {
  HorizontalProgress
};
